import { NgFor, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import { PrimeTemplate } from "primeng-v17/api";
import { MultiSelectModule } from "primeng-v17/multiselect";
import { EnumPipe } from "../../../shared/pipes/enum.pipe";
import { AppendToBodyDirective } from "../../../shared/primeng/append-to-body/append-to-body.directive";
import { MultiSelectEditableColumnAutoFocusDirective } from "../../../shared/primeng/multi-select-editable-column-auto-focus/multi-select-editable-column-auto-focus.directive";
import { MultiSelectReadonlyFixDirective } from "../../../shared/primeng/multi-select-readonly-fix/multi-select-readonly-fix.directive";
import { MultiSelectSelectedItemsLabelDirective } from "../../../shared/primeng/multi-select-selectedItemsLabel/multi-select-selectedItemsLabel.directive";
import { MultiSelectSortSelectedValuesOnTopDirective } from "../../../shared/primeng/multi-select-sort-selected-values-on-top/multi-select-empty.directive";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { ActivityIconComponent } from "../activity-icon/activity-icon.component";
import { NewUiActivityTypeSelectorComponent } from "./new-ui-activity-type-selector.component";

@Component({
  selector: "app-activity-type-selector",
  templateUrl: "./activity-type-selector.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: ActivityTypeSelectorComponent, multi: true }],
  imports: [
    TranslateDirective,
    MultiSelectModule,
    AppendToBodyDirective,
    MultiSelectEditableColumnAutoFocusDirective,
    MultiSelectReadonlyFixDirective,
    MultiSelectSelectedItemsLabelDirective,
    MultiSelectSortSelectedValuesOnTopDirective,
    FormsModule,
    PrimeTemplate,
    ActivityIconComponent,
    NgIf,
    NgFor,
    EnumPipe,
  ],
})
export class ActivityTypeSelectorComponent extends NewUiActivityTypeSelectorComponent {}
